var _defs, _polygon, _polygon2, _g, _g2, _polygon3, _polygon4, _polygon5, _g3, _g4, _g5, _g6, _g7, _polygon6, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUtility(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #6f6f6e;\n      }\n\n      .cls-2 {\n        fill: #585857;\n      }\n\n      .cls-3 {\n        fill: #c5c5c5;\n      }\n\n      .cls-4 {\n        fill: #8b7f6e;\n      }\n\n      .cls-5 {\n        fill: #a9a9aa;\n      }\n\n      .cls-6 {\n        fill: #5d6864;\n      }\n\n      .cls-7 {\n        fill: #a09f9f;\n      }\n\n      .cls-8 {\n        fill: #ececec;\n      }\n\n      .cls-9 {\n        fill: #65635f;\n      }\n\n      .cls-10 {\n        fill: #b1b1b0;\n      }\n\n      .cls-11 {\n        fill: #493522;\n      }\n\n      .cls-12 {\n        fill: #76614a;\n      }\n\n      .cls-13 {\n        fill: #3f3e3e;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "485.27 770.46 60.13 637.61 600.97 542.27 1019.87 599.97 485.27 770.46"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "444.47 575.36 444.47 352.21 812.65 371.2 812.65 645.68 444.47 575.36"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "478.27 461.97 623.5 480.29 623.5 609.55 624.75 609.79 624.75 479.18 477.02 460.54 477.02 581.57 478.27 581.81 478.27 461.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "478.27 461.97 478.27 581.81 623.5 609.55 623.5 480.29 478.27 461.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "619.32 608.75 482.46 582.61 482.46 466.71 619.32 483.98 619.32 608.75"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M579.28,535.02l26.82,3.31c2.42.3,4.58-1.42,4.58-3.66v-11.77c0-1.85-1.49-3.41-3.5-3.66l-26.82-3.31c-2.42-.3-4.58,1.42-4.58,3.66v11.77c0,1.85,1.49,3.41,3.5,3.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M610.68,506.32v-11.78c0-1.86-1.52-3.43-3.53-3.67l-26.82-3.08c-2.41-.28-4.54,1.44-4.54,3.67v11.78c0,1.86,1.52,3.43,3.53,3.67l26.82,3.08c2.41.28,4.54-1.44,4.54-3.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M521.41,508.36l-28.18-3.73c-2.43-.32-4.61,1.41-4.61,3.66v11.76c0,1.84,1.47,3.39,3.46,3.66l28.18,3.73c2.43.32,4.61-1.41,4.61-3.66v-11.76c0-1.84-1.47-3.39-3.46-3.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M568.56,501.43v-11.77c0-1.85-1.5-3.42-3.51-3.66l-28.39-3.42c-2.42-.29-4.56,1.43-4.56,3.66v11.77c0,1.85,1.5,3.42,3.51,3.66l28.39,3.42c2.42.29,4.56-1.43,4.56-3.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M532.09,569.64v12.94c0,1.78,1.39,3.31,3.3,3.63l28.39,4.85c2.48.42,4.78-1.32,4.78-3.63v-13.32c0-1.8-1.42-3.34-3.35-3.64l-28.39-4.46c-2.47-.39-4.72,1.35-4.72,3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M575.79,576.5v13.55c0,1.78,1.39,3.31,3.31,3.63l26.82,4.48c2.48.41,4.76-1.33,4.76-3.63v-13.93c0-1.81-1.43-3.35-3.37-3.64l-26.82-4.1c-2.46-.38-4.7,1.36-4.7,3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M488.61,562.41v12.18c0,1.76,1.35,3.27,3.23,3.62l28.18,5.26c2.5.47,4.84-1.28,4.84-3.62v-12.68c0-1.78-1.39-3.31-3.3-3.63l-28.18-4.76c-2.48-.42-4.77,1.32-4.77,3.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M521.39,535.68l-28.18-3.58c-2.43-.31-4.59,1.42-4.59,3.66v12.9c0,1.78,1.39,3.31,3.3,3.63l28.18,4.76c2.48.42,4.77-1.32,4.77-3.63v-14.08c0-1.84-1.49-3.41-3.48-3.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M521.36,480.74l-28.18-3.42c-2.42-.29-4.57,1.43-4.57,3.66v11.77c0,1.85,1.5,3.42,3.51,3.66l28.18,3.42c2.42.29,4.57-1.43,4.57-3.66v-11.77c0-1.85-1.5-3.42-3.51-3.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M532.09,541.25v14.66c0,1.8,1.42,3.34,3.35,3.64l28.39,4.46c2.47.39,4.72-1.35,4.72-3.64v-15.58c0-1.85-1.49-3.41-3.49-3.66l-28.39-3.54c-2.42-.3-4.58,1.42-4.58,3.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M565.09,513.99l-28.39-3.65c-2.43-.31-4.6,1.41-4.6,3.66v11.76c0,1.84,1.48,3.4,3.47,3.66l28.39,3.65c2.43.31,4.6-1.41,4.6-3.66v-11.76c0-1.84-1.48-3.4-3.47-3.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M579.16,566.42l26.82,4.1c2.46.38,4.7-1.36,4.7-3.64v-17.02c0-1.86-1.5-3.42-3.52-3.66l-26.82-3.2c-2.42-.29-4.56,1.43-4.56,3.66v16.11c0,1.81,1.43,3.35,3.37,3.64Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "681.07 500.97 739.42 508.3 739.42 631.52 740.67 631.74 740.67 507.24 679.81 499.61 679.81 620.49 681.07 620.72 681.07 500.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "681.07 500.97 681.07 620.72 739.42 631.52 739.42 508.3 681.07 500.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "735.23 630.75 685.25 621.48 685.25 504.5 735.23 510.82 735.23 630.75"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 728.36,
    cy: 572.8,
    r: 2.31
  }))), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "123.89 397.23 269.64 328.21 528.61 322.64 402.62 392.15 134.6 408.71 123.89 397.23"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "117.35 415 116.77 406.45 441.79 390.54 436.43 396.27 117.35 415"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "117.35 415 506.24 394.11 503.34 390.54 123.89 411.96 117.35 415"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "519.3 372.36 173.92 381.38 174.06 378.29 519.45 368.68 519.3 372.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "519.17 375.44 173.79 384.46 173.92 381.38 519.32 371.77 519.17 375.44"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "563.71 348.57 218.34 357.59 218.47 354.5 563.87 344.89 563.71 348.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "563.58 351.65 218.21 360.68 218.34 357.59 563.74 347.98 563.58 351.65"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "964.25 598.77 969.61 597.26 969.61 395.91 964.25 395.91 964.25 598.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "958.9 596.53 964.25 598.77 964.25 395.91 958.9 397.41 958.9 596.53"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "807.3 647.19 812.65 645.68 812.65 419.89 807.3 419.89 807.3 647.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "801.94 644.95 807.3 647.19 807.3 419.89 801.94 421.4 801.94 644.95"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "439.11 576.87 444.47 575.36 444.47 349.56 439.11 349.56 439.11 576.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "433.76 574.63 439.11 576.87 439.11 349.56 433.76 351.07 433.76 574.63"
  }))), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "812.65 645.68 962.67 598.77 962.67 395.91 812.65 411.79 812.65 645.68"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "807.3 639.97 508.7 730.92 508.7 738 807.3 647.05 807.3 639.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "807.3 639.97 508.7 730.92 506.02 726.76 801.94 638.17 807.3 639.97"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "506.24 497.13 504.36 507.61 458.68 434.99 467.14 434.99 506.24 497.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "506.24 497.13 513.25 498.86 467.56 426.24 467.14 434.99 506.24 497.13"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "508.7 738 514.06 736.49 514.06 446.43 508.7 446.43 508.7 738"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "503.34 735.76 508.7 738 508.7 446.43 503.34 447.94 503.34 735.76"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "595.83 496.38 593.95 506.86 548.27 434.24 556.74 434.24 595.83 496.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "595.83 496.38 602.84 498.11 557.16 425.49 556.74 434.24 595.83 496.38"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "598.29 703.31 603.65 701.8 603.65 445.68 598.29 445.68 598.29 703.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "592.94 701.07 598.29 703.31 598.29 445.68 592.94 447.19 592.94 701.07"
  })))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "685.42 470.02 683.55 480.5 637.86 407.88 646.33 407.88 685.42 470.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "685.42 470.02 692.43 471.75 646.75 399.13 646.33 407.88 685.42 470.02"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "687.89 676.96 693.24 675.45 693.24 419.33 687.89 419.33 687.89 676.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "682.53 674.72 687.89 676.96 687.89 419.33 682.53 420.84 682.53 674.72"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "775.02 442.04 773.14 452.52 727.46 379.9 735.93 379.9 775.02 442.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "775.02 442.04 782.03 443.77 736.34 371.15 735.93 379.9 775.02 442.04"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "777.48 648.98 782.84 647.47 782.84 391.35 777.48 391.35 777.48 648.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "772.12 646.74 777.48 648.98 777.48 391.35 772.12 392.86 772.12 646.74"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "129.69 627.22 129.69 634.3 439.11 576.85 439.11 569.77 129.69 627.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "129.69 627.22 439.11 569.77 433.76 567.97 129.69 622.94 129.69 627.22"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "222.9 609.31 228.26 608.65 228.26 403.09 222.9 403.09 222.9 609.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "217.55 607.08 222.9 609.31 222.9 403.09 217.55 404.6 217.55 607.08"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "326.52 360.52 228.26 403.09 222.9 403.09 321.16 360.52 326.52 360.52"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "223.11 445.67 222.9 437.61 246.65 392.8 252.07 390.54 223.11 445.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "223.11 445.67 228.26 445.67 257.22 390.54 252.07 390.54 223.11 445.67"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "217.55 405.66 217.55 401.64 321.16 355.52 321.16 360.52 217.55 405.66"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "322.38 590.84 327.74 590.17 327.74 393.7 322.38 393.7 322.38 590.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "317.02 588.6 322.38 590.84 322.38 393.7 317.02 395.21 317.02 588.6"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "425.99 351.13 327.74 393.7 322.38 393.7 420.64 351.13 425.99 351.13"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "322.59 436.28 322.38 428.22 346.13 383.41 351.55 381.15 322.59 436.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "322.59 436.28 327.74 436.28 356.7 381.15 351.55 381.15 322.59 436.28"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "317.02 396.27 317.02 392.24 420.64 346.13 420.64 351.13 317.02 396.27"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "402.62 576.07 407.98 575.41 407.98 388.12 402.62 388.12 402.62 576.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "397.27 573.83 402.62 576.07 402.62 388.12 397.27 389.63 397.27 573.83"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "506.24 345.55 407.98 388.12 402.62 388.12 500.88 345.55 506.24 345.55"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "402.83 430.7 402.62 422.64 426.37 377.83 431.79 375.57 402.83 430.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "402.83 430.7 407.98 430.7 436.94 375.57 431.79 375.57 402.83 430.7"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "397.27 390.69 397.27 386.66 500.88 340.55 500.88 345.55 397.27 390.69"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "129.24 634.31 134.6 633.64 134.6 401.18 129.24 401.18 129.24 634.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "123.89 632.07 129.24 634.31 129.24 401.18 123.89 402.69 123.89 632.07"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "232.86 358.61 134.6 401.18 129.24 401.18 227.5 358.61 232.86 358.61"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "129.45 443.75 129.24 435.7 152.99 390.89 158.41 388.63 129.45 443.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "129.45 443.75 134.6 443.75 163.56 388.63 158.41 388.63 129.45 443.75"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "123.89 403.75 123.89 399.72 227.5 353.61 227.5 358.61 123.89 403.75"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "269.64 325.17 102.89 402.99 103.44 404.18 269.64 326.36 269.64 325.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "269.64 325.17 505.13 446.43 505.13 447.63 269.64 326.36 269.64 325.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "986.94 392.15 505.13 446.43 505.13 447.63 986.94 393.34 986.94 392.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "986.94 392.15 505.13 446.43 269.64 325.17 774.8 309.54 986.94 392.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "269.64 338.98 109.09 415 109.09 404.24 269.64 328.21 269.64 338.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "269.64 338.98 505.13 460.01 505.13 449.24 269.64 328.21 269.64 338.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "103.44 404.18 109.09 404.24 269.64 328.21 269.64 326.36 103.44 404.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "109.09 415 269.64 338.98 274.76 341.61 117.35 415 109.09 415"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "269.64 328.21 269.64 326.36 505.13 447.63 505.13 449.24 269.64 328.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "980.6 401.03 505.13 460.01 505.13 449.24 980.6 395.91 980.6 401.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "980.6 395.91 980.6 394.06 505.13 447.63 505.13 449.24 980.6 395.91"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "584.7 315.42 805.49 412.59 817 411.3 596.11 315.07 584.7 315.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "428.68 320.25 657.15 429.31 669.17 427.95 440.48 319.88 428.68 320.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "331.57 323.26 563.79 439.83 576.12 438.44 343.59 322.88 331.57 323.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "350.97 322.65 582.5 437.72 594.77 436.34 362.95 322.28 350.97 322.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "643.43 313.6 860.77 406.36 872.08 405.09 654.68 313.26 643.43 313.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "545.62 316.63 768.53 416.76 780.17 415.45 557.13 316.27 545.62 316.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "604.26 314.82 823.94 410.51 835.38 409.22 615.62 314.46 604.26 314.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "623.84 314.21 842.37 408.44 853.74 407.16 635.15 313.86 623.84 314.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "312.18 323.86 545.07 441.94 557.45 440.54 324.25 323.48 312.18 323.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "467.61 319.04 694.36 425.11 706.26 423.77 479.32 318.68 467.61 319.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "292.8 324.45 526.32 444.05 538.76 442.65 304.91 324.08 292.8 324.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "409.24 320.85 638.52 431.41 650.6 430.04 421.08 320.48 409.24 320.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "448.14 319.65 675.76 427.21 687.72 425.86 459.89 319.28 448.14 319.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "487.1 318.44 712.93 423.02 724.77 421.69 498.75 318.08 487.1 318.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "526.1 317.23 750.02 418.84 761.72 417.52 537.66 316.88 526.1 317.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "370.38 322.05 601.19 435.61 613.4 434.24 382.32 321.68 370.38 322.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "506.59 317.84 731.48 420.93 743.26 419.6 518.2 317.48 506.59 317.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "389.8 321.45 619.86 433.51 632.01 432.14 401.69 321.08 389.8 321.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "565.15 316.03 787.02 414.67 798.6 413.37 576.61 315.67 565.15 316.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "721.93 311.17 934.17 398.09 945.2 396.85 732.97 310.83 721.93 311.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "269.64 325.17 505.13 446.43 520.05 444.75 285.59 324.68 269.64 325.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "702.28 311.78 915.85 400.16 926.95 398.91 713.38 311.44 702.28 311.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "682.65 312.39 897.52 402.22 908.69 400.97 693.8 312.04 682.65 312.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "986.94 392.15 774.8 309.54 761.27 309.96 970.73 393.98 986.94 392.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "663.03 313 879.16 404.29 890.4 403.03 674.23 312.65 663.03 313"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "752.58 310.23 741.59 310.57 952.46 396.03 963.42 394.8 752.58 310.23"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "210.12 367.16 225.27 359.99 307.75 358.61 321.8 365.78 210.12 367.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M210.12,367.16l111.68-1.38,1.33.69s-105.02,1.91-105.59,1.82-7.43-1.13-7.43-1.13Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtility);
export default __webpack_public_path__ + "static/media/Utility.d36e4cca4370153a251cfefa05e102d3.svg";
export { ForwardRef as ReactComponent };